import React, { useContext } from 'react';
import classNames from 'classnames';
import DisplayListingAnalitics from 'components/DisplayListingAnalitics';
import { useTranslation } from 'react-i18next';
import ListingContext from '../../../../providers/Listing/Listing.context';

import './ListingAnaliticsCard.styles.scss';

type ListingAnaliticsCardProps = {
  className?: string;
};

const ListingAnaliticsCard: React.FC<ListingAnaliticsCardProps> = (props) => {
  const { className } = props;

  const classes = classNames('listing-analitics-card', className);

  const { t } = useTranslation();

  const { listing } = useContext(ListingContext);

  const {
    viewsCounter,
    timeSpentCounter,
    enquiriesCounter,
    watchlistCounter,
    watchlistUsers,
  } = listing || {};

  return (
    <div className={classes}>
      <div className="card-heading">
        <p>{t('latestAnalytics')}</p>
      </div>

      <DisplayListingAnalitics
        timeSpentCounter={timeSpentCounter}
        viewsCounter={viewsCounter}
        enquiriesCounter={enquiriesCounter}
        watchlistCounter={watchlistCounter}
        watchlistUsers={watchlistUsers}
      />
    </div>
  );
};

export default ListingAnaliticsCard;
